import script from "./BaseTemplateLayerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateLayerItem.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateLayerItem.vue?vue&type=style&index=0&id=4c4c31e4&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4c31e4"]])

export default __exports__